import React from 'react'

import {Link} from 'gatsby'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText,
  EuiButton
} from '@elastic/eui'


import ivImage01 from '../../../../../images/Software/Windows/InstarVision/Record/Image043_small.webp'
import ivImage02 from '../../../../../images/Software/Windows/InstarVision/Record/Image041_small.webp'
import ivImage03 from '../../../../../images/Software/Windows/InstarVision/Record/Image042_small.webp'

export default function ImageCard() {

  return (
    <EuiFlexGroup gutterSize="l" direction="row" >
      <EuiFlexItem>
        <EuiCard
          textAlign="left"
          image={
            <div>
              <img
                src={ivImage01}
                alt="General settings for your video recording."
              />
            </div>
          }
          title="General Settings"
          description="General settings for your video recording."
          content={
            <EuiText>
              <p>General settings for your video recording.</p>
            </EuiText>
          }
          footer={
            <EuiFlexGroup justifyContent="flexEnd">
              <EuiFlexItem grow={false}>
                <Link to="/Software/Windows/InstarVision/Record/General/">
                  <EuiButton size="s" fill>
                    More
                  </EuiButton>
                </Link>
              </EuiFlexItem>
            </EuiFlexGroup>
          }
        />
        </EuiFlexItem>
        <EuiFlexItem>
        <EuiCard
          textAlign="left"
          image={
            <div>
              <img
                src={ivImage02}
                alt="Program regular video recording for your cameras."
              />
            </div>
          }
          title="Continuous Recording"
          description="Program regular video recording for your cameras."
          content={
            <EuiText>
              <p>Program regular video recording for your cameras.</p>
            </EuiText>
          }
          footer={
            <EuiFlexGroup justifyContent="flexEnd">
              <EuiFlexItem grow={false}>
                <Link to="/Software/Windows/InstarVision/Record/Continuous_Recording/">
                  <EuiButton size="s" fill>
                    More
                  </EuiButton>
                </Link>
              </EuiFlexItem>
            </EuiFlexGroup>
          }
        />
        </EuiFlexItem>
        <EuiFlexItem>
        <EuiCard
          textAlign="left"
          image={
            <div>
              <img
                src={ivImage03}
                alt="Activate motion detection and alarm recordings."
              />
            </div>
          }
          title="Alarm Recording"
          description="Activate motion detection and alarm recordings."
          content={
            <EuiText>
              <p>Activate motion detection and alarm recordings.</p>
            </EuiText>
          }
          footer={
            <EuiFlexGroup justifyContent="flexEnd">
              <EuiFlexItem grow={false}>
                <Link to="/Software/Windows/InstarVision/Record/Alarm_Recording/">
                  <EuiButton size="s" fill>
                    More
                  </EuiButton>
                </Link>
              </EuiFlexItem>
            </EuiFlexGroup>
          }
        />
        </EuiFlexItem>
    </EuiFlexGroup>
  );
}
